import { memo } from 'react';
import { TxCenterMapIcon } from '@icons';

type StatusBannerProps = {
  message: string;
  displayDate?: string;
  displayTime?: string;
  displayTz?: string;
};

export const StatusBanner = memo(({ message, displayDate, displayTime, displayTz }: StatusBannerProps) => {
  return (
    <div className="flex flex-col items-center justify-center w-full rounded-lg h-[75px]">
      <div className="flex items-center gap-1 mb-1">
        <div className="w-8 h-8 rounded-full bg-red-40 flex items-center justify-center">
          <TxCenterMapIcon className="w-6 h-6 text-base-5" />
        </div>
        {displayTime ? (
          <div className="flex items-center gap-1">
            <span className="text-xl-sb text-base-5 whitespace-nowrap">
              {displayDate ? <span>{displayDate}&nbsp;</span> : ''}
              {displayTime} {displayTz ? <span>{displayTz}</span> : ''}
            </span>
          </div>
        ) : null}
      </div>
      <span className="text-s-r text-base-20">{message}</span>
    </div>
  );
});
